import { Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'org-files-widget',
    templateUrl: './org-files-widget.component.html',
    styleUrls: ['./org-files-widget.component.scss'],
    standalone: false
})
export class OrgFilesWidget implements OnInit {
    @Input() widgetTitle: string;


  constructor() { }

  ngOnInit() {
  }

}
